/**
 * Fix Twitch thumbnail URLs by replacing template variables with actual dimensions
 */
export const fixThumbnailUrl = (url: string | undefined, width: number = 320, height: number = 180): string | undefined => {
  if (!url) return undefined;
  
  return url
    .replace('%{width}', width.toString())
    .replace('%{height}', height.toString());
};

/**
 * Generate multiple thumbnail sizes for responsive images
 */
export const getThumbnailSizes = (url: string | undefined) => {
  if (!url) return {};
  
  return {
    small: fixThumbnailUrl(url, 160, 90),
    medium: fixThumbnailUrl(url, 320, 180),
    large: fixThumbnailUrl(url, 640, 360),
  };
};